import { render, staticRenderFns } from "./SfTableData.vue?vue&type=template&id=3121b6c5"
import script from "./SfTableData.vue?vue&type=script&lang=js"
export * from "./SfTableData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  "3745a575"
  
)

export default component.exports